module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEySURBVHgBlZHfTcMwEMbvrikgnsoE+LENBTUTUDaADcoEdSagDIBqJigjsAFlglY0NHkjnYAB0vjwOUoVkPh3kpXz5Xf3fbYB/hBdvVA9nWjJ8Xd4NSSkGQArJlLBd6DSi84h7Y2BWVsu46rJKYgcQfumCTNhh5iHFmCJXMRrEy3DOGGv0IL2jAFyh208jHgO1iLD9iJ1YHPQtrRHgQOUZXubmdO5FEO9mjjh4/UXWCJAmBL8I5xsjic6ebJYbaoqDLw1p5qas8caljMUDBGVUFwj87MDR7KcxZz9nqZh/PrW0y+XO0stesfmhGoyxKnpG8m7OhmR8w2Ixv2YyC1Rw9/cfxHH8gaSZ6b/YLmInOKo5nYNFux9lbE6gGBQ1zMT5fu+yV6ld+Hm0y3II8qCH+ID/YaJJV0vrosAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advocate-blue.png
// module id = e+At
// module chunks = 1